// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2TBaK","messages":"Chat_messages__2Qu8p","dateDivider":"Chat_dateDivider__2WIyR"};